"use client";

import { LazyMotion, domMax } from "framer-motion";

/**
 * Loads framer-motion's animation features once, lazily, instead of every
 * file that imports `motion` pulling in the full library. Combined with
 * aliasing `m as motion` in each component's import line (same API,
 * identical JSX, no call-site changes), this cuts framer-motion's
 * contribution to the server bundle significantly - it was one of the
 * largest contributors pushing the Cloudflare Worker over its size limit.
 * domMax (not the smaller domAnimation) is used because the codebase relies
 * on drag and layout animations in several places.
 */
export function MotionProvider({ children }: { children: React.ReactNode }) {
  return (
    <LazyMotion features={domMax} strict={false}>
      {children}
    </LazyMotion>
  );
}
